import { setCurrentHrDocsThunkAction } from "./setCurrentHrDocs.thunk.action";
import { getUserHrDocsThunkAction } from "./getUserHrDocs.thunk.action";

import $api from "../../../../services/axiosService";


export const setViewedHrDocumentThuunkAction =
    (entityId, docId, workerId, typeViewTo, props, isViewed, file, entityType) =>
        async (dispatch) => {
            try {
                const document = await $api.get(
                    `${file.url}`,
                    { responseType: "blob" },
                );

                const blobLink = URL.createObjectURL(
                    new Blob([document.data],
                        { type: `${document.headers["content-type"]}` },
                    ),
                );
                if (file.url && (file.fileType || file.fileType === 0) && blobLink) {
                    window.open(blobLink);
                    if (!isViewed) {
                        // const response =
                        await $api.post(
                            `v2/directum/document/mark/asread/${entityId}/${docId}/${workerId}`, null, { params: { entityType } },
                        );
                    }
                    dispatch(
                        setCurrentHrDocsThunkAction(
                            entityId,
                            workerId,
                            typeViewTo,
                            entityType,
                        ),
                    );
                    dispatch(getUserHrDocsThunkAction({ entityType: 0 }));
                } else {
                    props.closeHandlerPackages();
                    props.setErrDescription(
                        "Что-то пошло не так, повторите попытку позже!",
                    );
                    props.helper();
                }
            } catch (e) {
                props.closeHandlerPackages();
                props.setErrDescription(
                    "Что-то пошло не так, повторите попытку позже!",
                );
                props.helper();
            }
        };
